module.exports = __webpack_public_path__ + "static/media/Cluster-2_2000.04e827f5.jpg";